import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const ANDREEA_PHOTO = 'https://cdn.magicpatterns.com/uploads/9gj5iqrEkvf8RHnMKQ6fGs/poza1.jpg';
const missionPoints = ['De la frică și nesiguranță, la claritate juridică reală', 'De la dependență și control, la puterea de a decide', 'De la singurătate în dosar, la sprijin complet în instanță'];
export function AboutSection() {
  return <section id="despre" className="bg-navy diagonal-pattern py-20 px-6" data-id="element-21">
      <div className="max-w-7xl mx-auto" data-id="element-22">
        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-23">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative flex justify-center" data-id="element-24">
            <div className="relative" data-id="element-25">
              {/* Emerald blob behind photo */}
              <div className="absolute -inset-10 bg-emerald/15 rounded-[30%_70%_70%_30%/30%_30%_70%_70%] blur-sm" data-id="element-26"></div>

              {/* Decorative gold circles */}
              <div className="absolute -top-5 -right-5 w-28 h-28 border border-gold/25 rounded-full z-0" data-id="element-27"></div>
              <div className="absolute -bottom-8 -left-8 w-36 h-36 border border-gold/15 rounded-full z-0" data-id="element-28"></div>

              {/* Decorative gold dots */}
              <div className="absolute -top-3 left-12 w-2.5 h-2.5 bg-gold/40 rounded-full z-0" data-id="element-29"></div>
              <div className="absolute bottom-16 -right-4 w-3 h-3 bg-gold/30 rounded-full z-0" data-id="element-30"></div>

              {/* Vertical emerald accent line */}
              <div className="absolute -left-6 top-10 bottom-10 w-[3px] bg-emerald/30 z-0" data-id="element-31"></div>

              {/* Gold corner frame */}
              <div className="relative gold-corner-frame" data-id="element-32">
                <img src={ANDREEA_PHOTO} alt="Andreea Saveli - Avocat Dreptul Familiei" className="relative z-10 w-full max-w-lg h-[640px] object-cover object-top rounded-lg shadow-2xl shadow-navy/50" data-id="element-33" />
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-34">
            <h2 className="text-text-light font-heading text-4xl md:text-5xl font-bold mb-4" data-id="element-35">
              Andreea Saveli
            </h2>

            <p className="text-gold font-label text-xs uppercase tracking-label mb-8" data-id="element-36">
              Avocat Specializat în Dreptul Familiei · Divorț · Partaj ·
              Moșteniri · 23 de ani de experiență
            </p>

            <div className="space-y-6 mb-10" data-id="element-37">
              <p className="text-text-light font-body text-base leading-relaxed" data-id="element-38">
                Sunt Andreea Saveli și lucrez de 23 de ani cu oameni care trec
                printr-una dintre cele mai dificile perioade din viața lor:
                divorțul, partajul, disputele legate de copii, moștenirile sau
                situațiile de violență domestică.
              </p>

              <p className="text-text-light-secondary font-body text-base leading-relaxed" data-id="element-39">
                Am văzut de sute de ori cum fricile cu care vin clienții mei nu
                corespund realității juridice. Cum amenințările partenerului nu
                sunt susținute de lege. Cum drepturile lor sunt mult mai bine
                protejate decât credeau.
              </p>

              <p className="text-text-light-secondary font-body text-base leading-relaxed" data-id="element-40">
                Prin Metoda celor 3 Pași pe care o aplic în fiecare dosar, totul
                începe cu o sesiune în care îți explic exact ce poți obține. Nu
                primești un răspuns standard, ci o strategie construită pe
                situația ta concretă. Și știi în orice moment unde se află
                dosarul tău.
              </p>
            </div>

            <div data-id="element-41">
              <h3 className="text-gold font-heading text-2xl font-bold mb-6" data-id="element-42">
                Misiunea mea
              </h3>
              <div className="space-y-4" data-id="element-43">
                {missionPoints.map((point, index) => <div key={index} className="flex items-start gap-3" data-id="element-44">
                    <CheckCircleIcon className="w-6 h-6 text-emerald flex-shrink-0 mt-1" strokeWidth={1.5} data-id="element-45" />
                    <p className="text-text-light font-body text-base leading-relaxed" data-id="element-46">
                      {point}
                    </p>
                  </div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}